import { Box, Collapse, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import {
  getAllExperimentsOfPatient,
  getExperimentInArea,
  getExperiments,
  suggestExperiment,
} from "../../../../api/area";
import DownArrow from "../../../../assets/SVG/downArrow";
import CustomizedHook from "../../../project/autocomplatePro";
import { InputCreateProject } from "../../../project/createProjectPop";
import TableLibray from "./tableLibray";

export default function Libraby({ moduleId }) {
  const [collapseAz, setCollapseAz] = useState();
  const [expresiment, setExpresiment] = useState();
  const [data, setData] = useState({
    experiment: "",
    description: "",
  });
  const [defData, setDefData] = useState([]);
  useEffect(() => {
    if (collapseAz) {
      getExperimentInArea()
        .then((x) => {
          setExpresiment(x);
        })
        .catch(() => {});
    }
  }, [collapseAz]);
  useEffect(() => {
    if (moduleId && collapseAz) {
      getAllExperimentsOfPatient(
        window.location.search.split("?", 3)[1].split("&", 3)[0],
        window.location.search.split("?", 3)[1].split("&", 4)[3]
      )
        .then((x) => {
          setDefData(x);
        })
        .catch(() => {});
    }
  }, [moduleId, collapseAz]);
  // console.log(defData);
  return (
    <Box
      // height={"80vh"}
      sx={{
        overflow: "auto",
        "::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <Box
        onClick={() => setCollapseAz(!collapseAz)}
        bgcolor="#EFF1F7"
        borderRadius={"7px"}
        p="10px"
        display="flex"
        justifyContent={"space-between"}
        alignItems="center"
        mt="20px"
        sx={{ cursor: "pointer" }}
      >
        <Typography color="var(--emr-darkblue)">
          {"فرم نسخه ازمایشگاه"}
        </Typography>
        <DownArrow transform={collapseAz} />
      </Box>
      <Collapse in={collapseAz} timeout="auto">
        <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
          <Box display="flex" width={"80%"} alignItems="end">
            <CustomizedHook
              multiple
              placeholder={"نام خدمت را انتخاب کنید"}
              label="نام خدمت"
              options={expresiment}
              onChange={(event, newValue) => {
                setData({ ...data, experiment: newValue.key });
              }}
              // value={data?.experiment}
            />
            <InputCreateProject
              placeholder={"علت درخواست را بنوسید"}
              label="علت درخواست"
              value={data?.description}
              onChange={(e) =>
                setData({
                  ...data,
                  description: e.target.value,
                })
              }
            />
            <botton
              style={{
                border: "none",
                backgroundColor: "var(--emr-darkblue)",
                color: "white",
                padding: "9px 40px",
                borderRadius: "10px",
                marginLeft: "10px",
                cursor: "pointer",
                marginRight: "20px",
                zIndex: "1",
                // height: "30px",
              }}
              onClick={() => {
                suggestExperiment(
                  window.location.search.split("?", 3)[1].split("&", 3)[0],
                  moduleId,
                  window.location.search.split("?", 3)[1].split("&", 4)[3],
                  data
                )
                  .then(() => {
                    // setDefData([...defData, data]);
                    getAllExperimentsOfPatient(
                      window.location.search.split("?", 3)[1].split("&", 3)[0],
                      window.location.search.split("?", 3)[1].split("&", 4)[3]
                    )
                      .then((x) => {
                        setDefData(x);
                      })
                      .catch(() => {});

                    setData({
                      experiment: "",
                      description: "",
                    });
                  })
                  .catch(() => {});
              }}
            >
              ثبت
            </botton>
          </Box>
          {defData?.length > 0 && (
            <TableLibray
              moduleId={moduleId}
              setRowData={setDefData}
              rowData={defData}
            />
          )}
        </Box>
      </Collapse>
    </Box>
  );
}
